import React from 'react';
import { Outlet } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useSiteStatus } from '../context/SiteStatusContext';
import ComingSoonPage from '../pages/ComingSoonPage';

const ComingSoonGate = () => {
  const { loading, comingSoonEnabled } = useSiteStatus();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5FBFB]">
        <Loader2 className="w-10 h-10 text-[#659A9B] animate-spin" aria-label="Loading" />
      </div>
    );
  }

  if (comingSoonEnabled) {
    return <ComingSoonPage />;
  }

  return <Outlet />;
};

export default ComingSoonGate;
